import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Video.svg?react
const SvgVideo = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M23 7L16 12L23 17V7Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M14 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H14C15.1046 19 16 18.1046 16 17V7C16 5.89543 15.1046 5 14 5Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/VideoIcon.tsx
function VideoIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgVideo,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { VideoIcon as t };
//# sourceMappingURL=VideoIcon-D9GPN5-k.js.map